import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { LocationRelatedDTO } from '../../map-features/sections/locations-section/models/LocationRelatedDTO';
@Injectable({
    providedIn: 'root'
  })


export class SwalNotificationService {

  public systemNotification: string = "";

  constructor(){
  }

  confirmMessage(title, message) {
      return Swal.fire({
        title: title,
        text: message,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Si',
        denyButtonText: 'No',
        cancelButtonText: 'Cancelar',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      });
  }

    message(text) {
      Swal.fire(text);
    }
  
    MessageSuccessful(title, text) {
      Swal.fire(title, text, "success");
    }
  
    MessageError(text) {
      Swal.fire("Algo salió mal", text, "error");
    }

    MessageInfo(text) {
      Swal.fire("Información", text, "info");
    }
  
    MessageDownloading(){
      return Swal.fire({
            title: 'Solicitud de Reporte en curso',
            text: 'El reporte está siendo procesado sin embargo éste proceso puede demorar unos minutos, le informaremos cuando esté listo',// add html attribute if you want or remove
            allowOutsideClick: false,
        });
    }
  
    MessageDetails(detailList: string[]) {
      let message = '<ul style="list-style-type: none; padding-left: 0;">'; // Comienza una lista HTML y quita los estilos por defecto
      
      // Itera sobre cada detalle y los agrega como elementos de lista
      detailList.forEach((detail, index) => {
        // Aplica estilos de tabla a cada elemento de lista
        message += `<li style="border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; padding: 5px 0;">${detail}</li>`;
      });
      
      message += '</ul>';
      
      return Swal.fire({
        title: 'El usuario ha realizado las siguientes acciones',
        html: message, 
        allowOutsideClick: false,
      });
    }

    MessageDetailsAsTable(detailsObjt: any) {
      let message = '<table style="border-collapse: collapse; width: 100%;">'; 
      
      // Llaves
      message += '<tr style="background-color: #f2f2f2;">';
      Object.keys(detailsObjt).forEach(key => {
        message += `<th style="border: 1px solid #ddd; padding: 2px; font-size: small; min-width: 70px;">${key}</th>`;
      });
      message += '</tr>';
      
      // Valores
      message += '<tr>';
      Object.values(detailsObjt).forEach(value => {
        message += `
          <td style="border: 1px solid #ddd; padding: 0px; font-size: x-small; max-width: 180px; height: 100px;">
            <div style="max-height: 100px; overflow-y: auto;">${value}</div>
          </td>`;
      });
      message += '</tr>';
      
      message += '</table>';
      
      return Swal.fire({
        title: 'Datos del log',
        html: message,
        width: '90%',
        allowOutsideClick: true,
      });
    }
    
  
    LocationsRelatedDetails(LocationRelated: LocationRelatedDTO) {
      let message = "";
    
      return Swal.fire({
        title: 'Detalles de ubicación',
        html: `
          <div class="popup-content">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque aliquid, amet eum nihil sunt alias eligendi.</p>
            <div class="address">
              <strong>Dirección:</strong>
              <p>Dirección de la ubicación</p>
            </div>
          </div>
        `,
        allowOutsideClick: false,
        confirmButtonColor: '#007bff',
        confirmButtonText: 'Aceptar',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'Cancelar'
      });
    }

    validarInputOdometro(inputElement: HTMLInputElement) {
      // solo pemrite un putno, de ahí, los elimina
      const dots = (inputElement.value.match(/\./g) || []).length;
      if (dots > 1) {
        const parts = inputElement.value.split('.');
        const first = parts.shift() || '';
        const rest = parts.join('');
        inputElement.value = first + '.' + rest;
      } else {
        inputElement.value = inputElement.value.replace(/[^\d.]/g, '');
      }
    }

    openOdometerSwal(title: string = 'Ingrese kilometraje', initialValue: string = '') {
      return Swal.fire({
        title: title,
        input: 'text',
        inputValue: initialValue,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        didOpen: () => {
          const inputEl = Swal.getInput() as HTMLInputElement;
          if (inputEl) {
            inputEl.addEventListener('input', () => this.validarInputOdometro(inputEl));
          }
        },
        preConfirm: (value) => {
          const inputEl = Swal.getInput() as HTMLInputElement;
          if (!inputEl) {
            Swal.showValidationMessage('Error interno: no se pudo leer');
            return false;
          }
          

          this.validarInputOdometro(inputEl);
          const val = (inputEl.value || '').trim();

          if (!val) {
            Swal.showValidationMessage('El kilometraje es requerido');
            return false;
          }

          if (!/^\d+(?:\.\d+)?$/.test(val)) {
            Swal.showValidationMessage('Formato inválido. Use solo números y un punto decimal si es necesario');
            return false;
          }

          return val;
        }
      });
    }

    openAliasSwal(title: string = 'Ingrese alias', initialValue: string = '') {
      return Swal.fire({ 
        title: title,
        input: 'text',
        inputValue: initialValue,
        inputAttributes: {
          maxlength: '30'
        },
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        preConfirm: () => {
          const inputEl = Swal.getInput() as HTMLInputElement;
          if (!inputEl) {
            Swal.showValidationMessage('Error interno: no se pudo leer');
            return false;
          }
          const val = (inputEl.value || '').trim();

          if (!val) {
            Swal.showValidationMessage('El alias es requerido');
            return false;
          }

          if (val.length > 30) {
            Swal.showValidationMessage('El alias no puede tener más de 30 caracteres');
            return false;
          }

          return val;
        }
      });
    }

    showCustomSuccess(title: string, text: string, buttonText: string = 'Aceptar') {
      return Swal.fire({
        html: `
          <div class="custom-swal-content">
            <div class="custom-swal-icon">
              <i class="material-icons">check_circle</i>
            </div>
            <h2 class="custom-swal-title">${title}</h2>
            <p class="custom-swal-text">${text}</p>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonText: buttonText,
        showCloseButton: false,
        allowOutsideClick: true,
        customClass: {
          popup: 'custom-swal-popup',
          confirmButton: 'custom-swal-confirm-btn'
        },
        buttonsStyling: false
      });
    }

    customConfirmMessage(title: string, text: string, confirmText: string = 'Sí', denyText: string = 'No') {
      return Swal.fire({
        html: `
          <div class="custom-swal-content">
            <div class="custom-swal-icon">
              <i class="material-icons">error</i>
            </div>
            <h2 class="custom-swal-title">${title}</h2>
            <p class="custom-swal-text">${text}</p>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonText: confirmText,
        showDenyButton: true,
        denyButtonText: denyText,
        showCloseButton: false,
        allowOutsideClick: true,
        customClass: {
          popup: 'custom-swal-confirmation-popup',
          confirmButton: 'custom-swal-confirm-btn',
          denyButton: 'custom-swal-deny-btn'
        },
        buttonsStyling: false
      });
    }

    customConfirmMessageInPanel(title: string, text: string, confirmText: string = 'Sí', denyText: string = 'No') {
      return Swal.fire({
        html: `
          <div class="custom-swal-content">
            <div class="custom-swal-icon">
              <i class="material-icons">error</i>
            </div>
            <h2 class="custom-swal-title">${title}</h2>
            <p class="custom-swal-text">${text}</p>
          </div>
        `,
        showConfirmButton: true,
        confirmButtonText: confirmText,
        showDenyButton: true,
        denyButtonText: denyText,
        showCloseButton: false,
        allowOutsideClick: true,
        backdrop: 'rgba(0,0,0,0.1)',
        customClass: {
          popup: 'custom-swal-panel-confirmation-popup',
          confirmButton: 'custom-swal-confirm-btn',
          denyButton: 'custom-swal-deny-btn'
        },
        buttonsStyling: false
      });
    }
}
